import { Injectable } from '@angular/core';

import { Country } from '@app/shared/models/country.model';
import { Observable } from 'rxjs';
import { CountriesStoreService } from '../stores/countries-store.service';

@Injectable()
export class CountriesResolverService {
    constructor(private countriesStoreService: CountriesStoreService) {}

    resolve(): Observable<Country[]> {
        return this.countriesStoreService.setCountries();
    }
}
